import {
    api_logInUser,
    api_signUpUser,
    api_patchPassword,
    api_applyReferralCode,
    api_getUserByID,
    api_getUser
} from "./user.api";
import {
    setUser,
    clearUser,
    setUserReferralCodeRequest,
    setUserSubscription
} from "./user.reducers";


export const logInUser = params => dispatch => (
    api_logInUser(params).then(res => {
        dispatch(setUser(res));
        localStorage.setItem("auth", JSON.stringify({
            token: res.token,
            expiresAt: res.expiresAt,
            userId: res.userId,
            role: res.role,
            email: res.email,
            url: res?.partnerUrl,
        }));
        return res;
    })
);

export const signUpUser = params => dispatch => (
    api_signUpUser(params).then(res => {
        dispatch(setUser(res.authenticationToken));
        localStorage.setItem("auth", JSON.stringify({
            token: res.authenticationToken.token,
            expiresAt: res.authenticationToken.expiresAt,
            userId: res.authenticationToken.userId,
            role: res.authenticationToken.role,
            email: res.authenticationToken.email,
            url: res?.partnerUrl,
        }));
        return res;
    })
);

export const patchPassword = params => dispatch => (
    api_patchPassword(params).then(res => {
        return res;
    })
);

export const logOutUser = () => dispatch => {
    sessionStorage.removeItem("persist:root");
    dispatch(clearUser());
};

export const postReferralCode = code => dispatch => (
    api_applyReferralCode(code).then(res => {
        dispatch(setUserReferralCodeRequest(res[0]));
        return res[0];
    })
);

export const getUserByID = id => dispatch => (
    api_getUserByID(id).then(res => {
        dispatch(setUserReferralCodeRequest(res.referralCodeRequest));
        if (res.ownerSubscriptionPlans.length > 0) {
            dispatch(setUserSubscription(true));
        }
        return res;
    })
);

export const getUser = id => dispatch => (
    api_getUser(id).then(res => {
        return res;
    })
);
